module.exports = __webpack_public_path__ + "static/media/Dayly_ios_1_preview.2fbf63df.jpg";